import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Header from '@components/header/Header'
import ManifestationCard from './ManifestationListCard'

import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'
import useBreakpoint from '@utils/useBreakpoints'

import { firstLetterUppercase } from '@utils/stringUtils'

interface Props {
  section: ManifestationsSection
}

const ManifestationsMonthScreen = ({ section }: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  React.useEffect(() => {
    if (!section) {
      navigation.push('/manifestations')
    }
  }, [])

  const [, currentBreakpoint] = useBreakpoint()
  const isPhone = currentBreakpoint === 'phone'

  if (!section) {
    return null
  }

  const onBack = () => navigation.goBack()

  const renderManifestation = (manifestation: ManifestationResponse) => (
    <ManifestationContainer key={manifestation.id}>
      <ManifestationCard
        manifestation={manifestation}
        onClick={() => navigation.push(`/manifestation/${manifestation.id}`, { manifestationId: manifestation.id })}
      />
    </ManifestationContainer>
  )

  const title = i18n.t('screens.manifestations.sectionDate', { date: new Date(section.section) })

  return (
    <Root header={firstLetterUppercase(title)} onLeft={onBack}>
      {!isPhone && <Header title={firstLetterUppercase(title)} />}
      <MainContainer>
        {section.manifestations.length > 0 ? (
          <ManifestationList>{section.manifestations.map(renderManifestation)}</ManifestationList>
        ) : (
          <MissingInfo>{i18n.t('screens.manifestations.noManifestation')}</MissingInfo>
        )}
      </MainContainer>
    </Root>
  )
}

export default ManifestationsMonthScreen

const MainContainer = styled(View)`
  display: flex;
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? `16px` : '24px')};
`
const MissingInfo = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  font-size: 14px;
  color: ${(props) => props.theme.colors.secondaryText};
  ${(props) =>
    props.theme.breakpoint === 'phone'
      ? ` padding: 23px 16px;
          background-color: ${props.theme.colors.background};
          text-align: center;
          font-size: 12px;`
      : `padding: 16px 0px;`}
`
const ManifestationContainer = styled(View)`
  ${(props) => (props.theme.breakpoint === 'phone' ? 'margin-bottom: 8px;' : 'margin: 0px 16px 16px 0px;')}
`
const ManifestationList = styled(View)`
  flex-direction: ${(props) => (props.theme.breakpoint === 'phone' ? 'column' : 'row')};
  ${(props) => props.theme.breakpoint !== 'phone' && `flex-wrap: wrap;`}
`
